import { useUserStore } from '@/stores/user.js'

export default function paymentPlan(paymentPlanLevel = 0) {
  return async function ({ next }) {
    try {
      const userStore = useUserStore()
      if (parseInt(userStore.currentOrganization?.plan || '0') < paymentPlanLevel) {
        return next({ name: 'dashboard' })
      }
      return next()
    } catch (e) {
      return next({ name: 'login' })
    }
  }
}
